<template>
  <v-flex xs12 sm12 d-block class="card-dados">
    <v-layout wrap align-center white>
      <v-flex xs12 sm3 d-flex>
        <div id="numeroProcesso" class="az-text">
          <label>Nº Processo</label>
          <p>
            {{value.processo ? value.processo : '--'}}
          </p>
        </div>
      </v-flex>
      <v-flex xs12 sm3 d-flex>
        <div id="orgao" class="az-text">
          <label>Orgão</label>
          <p>
            {{value.comprador && value.comprador.sigla ? value.comprador.sigla : '--'}}
          </p>
        </div>
      </v-flex>
      <v-flex xs12 sm3 d-flex id="recurso-federal">
        <div class="az-text">
          <label>Recurso Federal</label>
          <p>{{value.recursoFederal ? 'Sim' : 'Não'}}</p>
        </div>
      </v-flex>
      <v-flex xs12 sm3 d-flex v-if="value.tipo === 'COM_DISPUTA'">
        <div id="disputaPor" class="az-text">
          <label>Disputa por</label>
          <p>{{value.disputaPor | cdEnum(disputasCompraDireta)}}</p>
        </div>
      </v-flex>
    </v-layout>
    <v-layout wrap align-center white>
      <v-flex xs12 sm3 d-flex>
        <div id="situacao" class="az-text">
          <label>Situação</label>
          <p>{{value.situacao | azEnum(situacoesCompraDireta)}}</p>
        </div>
      </v-flex>
      <v-flex xs12 sm3 d-flex>
        <div id="numeroCompraDireta" class="az-text">
          <label>Nº Compra Direta</label>
          <p>
            {{value.numero ? `${value.numero}/${value.ano}` : '--'}}
          </p>
        </div>
      </v-flex>
      <v-flex xs12 sm3 d-flex>
        <div id="amparoLegal" class="az-text">
          <label>Amparo Legal</label>
          <p>{{value.amparoLegal ? value.amparoLegal.lei : '--'}}</p>
        </div>
      </v-flex>
      <v-flex xs12 sm3 d-flex>
        <div id="tipo" class="az-text">
          <label>Tipo</label>
          <p>{{value.tipo | cdEnum(tiposCompraDireta)}}</p>
        </div>
      </v-flex>
      <v-flex xs12 sm3 d-flex>
        <div class="az-text">
          <label>Critério de Julgamento</label>
          <p>{{criterioJulgamentoDaCompra}}</p>
        </div>
      </v-flex>
      <v-flex xs12 sm3 d-flex>
        <div id="dataHoraAbertura" class="az-text">
          <label>Data/Hora de Criação</label>
          <p>{{value.dataHoraAbertura | az-date(humanizarFormatoDataHora(value.dataHoraAbertura))}}</p>
        </div>
      </v-flex>
      <v-flex xs12 sm3 d-flex>
        <div id="dataHoraInicioEnvioPropostas" class="az-text">
          <label>Data/Hora Inicio Envio Propostas</label>
          <p>{{value.dataHoraInicioEnvioPropostas | az-date(humanizarFormatoDataHora(value.dataHoraInicioEnvioPropostas))}}</p>
        </div>
      </v-flex>
      <v-flex xs12 sm3 d-flex>
        <div id="dataHoraFimEnvioPropostas" class="az-text">
          <label>Data/Hora Fim Envio Propostas</label>
          <p>{{value.dataHoraFimEnvioPropostas | az-date(humanizarFormatoDataHora(value.dataHoraFimEnvioPropostas))}}</p>
        </div>
      </v-flex>
      <v-flex v-if="value.tipo === 'COM_DISPUTA'" xs12 sm3 d-flex>
        <div id="duracaoEtapaDeLances" class="az-text">
          <label>Duração Etapa de Lances</label>
          <p>{{value.duracaoEtapaLances ? value.duracaoEtapaLances : '--'}}</p>
        </div>
      </v-flex>

      <v-flex xs12 sm3 d-flex>
        <div id="contato" class="az-text">
          <label>Contato</label>
          <p>{{value.nomeContato ? value.nomeContato : '--'}}</p>
        </div>
      </v-flex>
      <v-flex xs12 sm3 d-flex>
        <div id="telefone" class="az-text">
          <label>Telefone</label>
          <p>{{value.telefoneContato | az-phone}}</p>
        </div>
      </v-flex>
      <v-flex xs12 sm3 d-flex>
        <div id="prazoEntrega" class="az-text">
          <label>Prazo de Entrega</label>
          <p>{{value.prazoEntregaDescritivo ? `${value.prazoEntregaDescritivo}` : '--'}}</p>
        </div>
      </v-flex>
      <v-flex xs12 sm3 d-flex>
        <div id="localEntrega" class="az-text">
          <label>Local de Entrega</label>
          <p>{{value.localEntrega ? value.localEntrega : '--'}}</p>
        </div>
      </v-flex>
      <v-flex v-if="ehLei14_133(value.amparoLegal)" xs12 sm3 d-flex>
        <div id="possuiValorReferencia" class="az-text">
          <label>Dispensa sem Valor Estimado</label>
          <p>{{value.possuiValorReferencia ? 'Não' : 'Sim' }}</p>
        </div>
      </v-flex>
      <v-flex v-if="value.possuiValorReferencia || !ehLei14_133(value.amparoLegal)" xs12 sm3 d-flex>
        <div id="valorReferencia" class="az-text">
          <label>Exibir Valor de Referência</label>
          <p>{{value.exibeValorReferencia ? 'Sim' : 'Não' }}</p>
        </div>
      </v-flex>
      <v-flex xs12 sm3 d-flex>
        <div id="criadoPor" class="az-text">
          <label>Criado por</label>
          <p>{{value.criadoPor ? value.criadoPor : '--'}}</p>
        </div>
      </v-flex>
    </v-layout>
    <v-layout wrap align-center white class="visualizacaoRecursoFederal">

    </v-layout>
    <v-layout wrap align-center white v-if="deveMostrarIntervaloDeLances">
      <v-flex xs12 sm3 d-flex ma-0>
        <div class="az-text">
          <label>Diferença Mínima entre Lances</label>
          <p>{{montarDiferencaEntreLances}}</p>
        </div>
      </v-flex>
    </v-layout>
    <v-layout wrap align-center white>
      <v-flex xs12 sm3 d-flex>
        <div id="objeto" class="az-text">
          <label>Objeto</label>
          <p>
            {{value.objeto ? value.objeto : '--'}}
          </p>
        </div>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>

import {situacoesCompraDireta} from '@/core/constants'
import cdEnum from '@/views/filters/cdEnum'

export default {
    name: 'PainelCompraDiretaVisualizacao',
    props: {
        value: {
            required: true
        },
    },
    filters: {
        cdEnum
    },
    data() {
        return {
            disputasCompraDireta: {
                UNITARIO: {texto: 'Valor Unitário', valor: 'UNITARIO'},
                TOTAL: {texto: 'Valor Total', valor: 'TOTAL'}
            },
            situacoesCompraDireta,
            tiposCompraDireta: {
                COM_DISPUTA: {texto: 'Com Disputa', valor: 'COM_DISPUTA'},
                SEM_DISPUTA: {texto: 'Sem Disputa', valor: 'SEM_DISPUTA'}
            },
            criteriosJulgamento: {
                MENOR_PRECO: {texto: 'Menor Preço', valor: 'MENOR_PRECO'},
                MAIOR_DESCONTO: {texto: 'Maior Desconto', valor: 'MAIOR_DESCONTO'},
            },
            validacaoIntervaloLances: {
                VALOR: {texto: 'Valor (R$)', valor: 'VALOR'},
                PERCENTUAL: {texto: 'Percentual (%)', valor: 'PERCENTUAL'},
            },
            formatosDefault: {
                DATA: 'DD/MM/YYYY',
                DATA_HORA: 'DD/MM/YYYY [-] HH[h]',
                DATA_HORA_MINUTO: 'DD/MM/YYYY [-] HH[h] mm[min]',
                HORA: 'HH[h] mm[min]'
            }
        }
    },
    computed: {
        montarDiferencaEntreLances() {
            if(!this.value.intervaloLances || !this.value.validarIntervaloLancesPor)
                return '--'

            const texto = this.validacaoIntervaloLances[this.value.validarIntervaloLancesPor].texto

            return texto ? `${texto} - ${this.value.intervaloLances}` : '--'
        },
        criterioJulgamentoDaCompra() {
            if(!this.value.criterioJulgamento) return '--'

            return this.criteriosJulgamento[this.value.criterioJulgamento].texto
        },
        deveMostrarIntervaloDeLances() {
            return this.ehLei14_133(this.value.amparoLegal) && (this.value.tipo && this.value.tipo === 'COM_DISPUTA')
        }
    },
    methods: {
        ehLei14_133(amparoLegal) {
            const lei = amparoLegal && amparoLegal.lei
            return !!(lei && lei.includes('14.133/2021'))
        },
        humanizarFormatoDataHora() {
            return this.formatosDefault.DATA_HORA_MINUTO
        }
    }
}
</script>
